import React, { useState, useContext } from 'react';
import { Typography, Box, Button, Rating, TextField } from '@mui/material';
import SurfaceCard from './building_blocks/SurfaceCard';
import orderReviewsPathTo from '../utils/Api/orderReviewsPathTo';
import SnackbarContext from '../contexts/SnackbarContext';

const OrderReview = ({ order, setOrder }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const { openSnackbar } = useContext(SnackbarContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!rating) {
      openSnackbar('Por favor, avalie o pedido!', 'error');
      return;
    }
    orderReviewsPathTo.save({ rating, comment, order_id: order.id }).then((result) => {
      setOrder(result.data);
      openSnackbar('Muito obrigado por avaliar o pedido!', 'success');
    });
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: 480, md: 560 },
        alignSelf: 'center',
      }}
    >
      <SurfaceCard sx={{ flexDirection: 'column', gap: 2 }}>
        <Typography variant="sectionTitle">Avaliação do Pedido</Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, alignSelf: 'stretch' }}
        >
          <Rating
            name="rating"
            size="large"
            value={rating}
            onChange={(event, newValue) => setRating(newValue)}
          />

          <TextField
            label="Comentário (opcional)"
            multiline
            variant="outlined"
            fullWidth
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />

          <Button type="submit" variant="pillContained" color="primary" sx={{ alignSelf: { xs: 'stretch', sm: 'flex-end' } }}>
            Enviar Avaliação
          </Button>
        </Box>
      </SurfaceCard>
    </Box>
  );
};

export default OrderReview;
